import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { css, Box, Flex, SystemProps, Icon, Text } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import { useMeasure } from "react-use";
import { ArrowDown, ArrowUp, Minus, Plus } from "~components/common/Icons";

export interface AccordionProps extends SystemProps {
  title: string;
  children: ReactNode | string;
  close?: boolean;
  isOpen?: boolean;
  withoutLastBorder?: boolean;
  isFirst?: boolean;
  isFAQ?: boolean;
  isTags?: boolean;
  tags?: any;
}

export const NhAccordion = ({
  title,
  children,
  close,
  isOpen,
  withoutLastBorder = false,
  isFirst,
  tags,
  isTags = false,
  isFAQ = false,
  ...props
}: AccordionProps) => {
  const [open, setOpen] = useState(() => (isOpen ? true : false));
  const [ref, { height }] = useMeasure();
  const { query } = useRouter();
  const count = useMemo(() => {
    if (!tags) return null;
    switch (title) {
      case "Niveau":
        return Number(!!query.difficulty);
      case "Categorieën":
        return Number(!!query.category);
      default:
        return query.tags
          ? String(query.tags)
              .split(",")
              .filter((item) => tags.find(({ value }) => value === item)).length
          : 0;
    }
  }, [query]);
  useEffect(() => {
    if (close) setOpen(false);
  }, [close]);
  useEffect(() => {
    if (!isOpen) setOpen(false);
  }, [isOpen]);
  return (
    <Box
      borderTop={isFirst ? "1px solid grey200" : "none"}
      borderBottom={
        isFAQ ? "none" : !withoutLastBorder ? "1px solid grey200" : "none"
      }
      mt="-1px"
      border={isFAQ ? "1px solid #E2DFDF" : "auto"}
      borderRadius={isFAQ ? "8px" : "none"}
      textAlign="left"
      mb={isFAQ && 1}
    >
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
        /** @ts-ignore this is an indication of whats wrong with the return type of the polymorph */
        onClick={() => setOpen(!open)}
        py={["12px", "16px"]}
        px={(isFAQ || isTags) && "16px"}
        cursor="pointer"
        {...props}
      >
        <Box display={"flex"} alignItems={"center"} position={"relative"}>
          <Text
            fontSize={isFAQ ? "18px" : "18px"}
            fontWeight={500}
            lineHeight={"25.2px"}
          >
            {title}
          </Text>
          {!!count && (
            <Box
              ml={1}
              fontSize={"10px"}
              fontWeight={700}
              lineHeight={"15px"}
              textAlign={"center"}
              fontFamily={"DINPro"}
              width={16}
              height={16}
              backgroundColor={"#C39A91"}
              borderRadius={"full"}
            >
              {count}
            </Box>
          )}
        </Box>

        <Flex>
          <Icon
            icon={open ? (isFAQ ? ArrowDown : Minus) : isFAQ ? ArrowUp : Plus}
            pt="3px"
            fontSize={isFAQ ? "16px" : "20px"}
          />
        </Flex>
      </Flex>
      <Box
        maxHeight={open ? [`${height + 3 * 8}px`, `${height + 4 * 8}px`] : 0}
        transition="max-height ease 0.3s"
        overflow="hidden"
      >
        <Box
          pb={["12px", "16px"]}
          px={isFAQ && "16px"}
          transition="opacity ease 0.25s"
          opacity={open ? 1 : 0}
          ref={ref}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
